import { Flex } from "antd";
import styled from "styled-components";

export const StyledMarketCardSelectable = styled(Flex)`
    &:not(&:last-child) {
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.primaryBackground};
    }
`;
